import { useState, useEffect } from 'react';

const useAddToCart = () => {
  const [cart, setCart] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('lootlayer_cart')) || [];
    } catch {
      return [];
    }
  });

  // Sync with localStorage whenever cart changes
  useEffect(() => {
    localStorage.setItem('lootlayer_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (product, qtyOverride) => {
    const quantityToAdd = qtyOverride ?? product.quantity ?? 1;

    setCart(prevCart => {
      const existingItem = prevCart.find(item => item.sku === product.sku);
      if (existingItem) {
        // Ensure we respect stock
        const newQuantity = Math.min(
          existingItem.quantity + quantityToAdd,
          product.stock ?? Infinity
        );
        return prevCart.map(item =>
          item.sku === product.sku ? { ...item, quantity: newQuantity } : item
        );
      } else {
        return [...prevCart, { ...product, quantity: quantityToAdd }];
      }
    });
  };

  const removeFromCart = sku => setCart(prev => prev.filter(i => i.sku !== sku));

  const clearCart = () => setCart([]);

  const updateQuantity = (sku, quantity) => {
    if (quantity < 1) return;
    setCart(prev =>
      prev.map(item => (item.sku === sku ? { ...item, quantity } : item))
    );
  };

  return { cart, addToCart, removeFromCart, clearCart, updateQuantity };
};

export default useAddToCart;
